/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { RequestsRequestAgentPlacementPost } from '../models';
// @ts-ignore
import { RequestsRequestHardwareRentOutPost } from '../models';
// @ts-ignore
import { RequestsRequestHardwareRentPost } from '../models';
// @ts-ignore
import { RequestsRequestLLMBusinessPost } from '../models';
// @ts-ignore
import { RequestsRequestLLMPersonalPost } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * RequestsApi - axios parameter creator
 * @export
 */
export const RequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Store an agent placement request
         * @summary Agent placement request
         * @param {RequestsRequestAgentPlacementPost} [requestsRequestAgentPlacementPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAgentPlacement: async (requestsRequestAgentPlacementPost?: RequestsRequestAgentPlacementPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request/agent_placement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestsRequestAgentPlacementPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a hardware rent request
         * @summary Hardware rent request
         * @param {RequestsRequestHardwareRentPost} [requestsRequestHardwareRentPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestHardwareRent: async (requestsRequestHardwareRentPost?: RequestsRequestHardwareRentPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request/hardware_rent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestsRequestHardwareRentPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a hardware rent out request
         * @summary Hardware rent out request
         * @param {RequestsRequestHardwareRentOutPost} [requestsRequestHardwareRentOutPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestHardwareRentOut: async (requestsRequestHardwareRentOutPost?: RequestsRequestHardwareRentOutPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request/hardware_rent_out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestsRequestHardwareRentOutPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a LLM business request
         * @summary LLM business request
         * @param {RequestsRequestLLMBusinessPost} [requestsRequestLLMBusinessPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLLMBusiness: async (requestsRequestLLMBusinessPost?: RequestsRequestLLMBusinessPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request/llm_business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestsRequestLLMBusinessPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a LLM personal request
         * @summary LLM personal request
         * @param {RequestsRequestLLMPersonalPost} [requestsRequestLLMPersonalPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLLMPersonal: async (requestsRequestLLMPersonalPost?: RequestsRequestLLMPersonalPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/request/llm_personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestsRequestLLMPersonalPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RequestsApi - functional programming interface
 * @export
 */
export const RequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * Store an agent placement request
         * @summary Agent placement request
         * @param {RequestsRequestAgentPlacementPost} [requestsRequestAgentPlacementPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAgentPlacement(requestsRequestAgentPlacementPost?: RequestsRequestAgentPlacementPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAgentPlacement(requestsRequestAgentPlacementPost, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestsApi.requestAgentPlacement']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Store a hardware rent request
         * @summary Hardware rent request
         * @param {RequestsRequestHardwareRentPost} [requestsRequestHardwareRentPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestHardwareRent(requestsRequestHardwareRentPost?: RequestsRequestHardwareRentPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestHardwareRent(requestsRequestHardwareRentPost, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestsApi.requestHardwareRent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Store a hardware rent out request
         * @summary Hardware rent out request
         * @param {RequestsRequestHardwareRentOutPost} [requestsRequestHardwareRentOutPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestHardwareRentOut(requestsRequestHardwareRentOutPost?: RequestsRequestHardwareRentOutPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestHardwareRentOut(requestsRequestHardwareRentOutPost, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestsApi.requestHardwareRentOut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Store a LLM business request
         * @summary LLM business request
         * @param {RequestsRequestLLMBusinessPost} [requestsRequestLLMBusinessPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestLLMBusiness(requestsRequestLLMBusinessPost?: RequestsRequestLLMBusinessPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestLLMBusiness(requestsRequestLLMBusinessPost, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestsApi.requestLLMBusiness']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Store a LLM personal request
         * @summary LLM personal request
         * @param {RequestsRequestLLMPersonalPost} [requestsRequestLLMPersonalPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestLLMPersonal(requestsRequestLLMPersonalPost?: RequestsRequestLLMPersonalPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestLLMPersonal(requestsRequestLLMPersonalPost, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RequestsApi.requestLLMPersonal']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RequestsApi - factory interface
 * @export
 */
export const RequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RequestsApiFp(configuration)
    return {
        /**
         * Store an agent placement request
         * @summary Agent placement request
         * @param {RequestsApiRequestAgentPlacementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAgentPlacement(requestParameters: RequestsApiRequestAgentPlacementRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestAgentPlacement(requestParameters.requestsRequestAgentPlacementPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a hardware rent request
         * @summary Hardware rent request
         * @param {RequestsApiRequestHardwareRentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestHardwareRent(requestParameters: RequestsApiRequestHardwareRentRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestHardwareRent(requestParameters.requestsRequestHardwareRentPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a hardware rent out request
         * @summary Hardware rent out request
         * @param {RequestsApiRequestHardwareRentOutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestHardwareRentOut(requestParameters: RequestsApiRequestHardwareRentOutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestHardwareRentOut(requestParameters.requestsRequestHardwareRentOutPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a LLM business request
         * @summary LLM business request
         * @param {RequestsApiRequestLLMBusinessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLLMBusiness(requestParameters: RequestsApiRequestLLMBusinessRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestLLMBusiness(requestParameters.requestsRequestLLMBusinessPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a LLM personal request
         * @summary LLM personal request
         * @param {RequestsApiRequestLLMPersonalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestLLMPersonal(requestParameters: RequestsApiRequestLLMPersonalRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestLLMPersonal(requestParameters.requestsRequestLLMPersonalPost, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RequestsApi - interface
 * @export
 * @interface RequestsApi
 */
export interface RequestsApiInterface {
    /**
     * Store an agent placement request
     * @summary Agent placement request
     * @param {RequestsRequestAgentPlacementPost} [requestsRequestAgentPlacementPost] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApiInterface
     */
    requestAgentPlacement(requestsRequestAgentPlacementPost?: RequestsRequestAgentPlacementPost, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Store a hardware rent request
     * @summary Hardware rent request
     * @param {RequestsRequestHardwareRentPost} [requestsRequestHardwareRentPost] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApiInterface
     */
    requestHardwareRent(requestsRequestHardwareRentPost?: RequestsRequestHardwareRentPost, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Store a hardware rent out request
     * @summary Hardware rent out request
     * @param {RequestsRequestHardwareRentOutPost} [requestsRequestHardwareRentOutPost] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApiInterface
     */
    requestHardwareRentOut(requestsRequestHardwareRentOutPost?: RequestsRequestHardwareRentOutPost, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Store a LLM business request
     * @summary LLM business request
     * @param {RequestsRequestLLMBusinessPost} [requestsRequestLLMBusinessPost] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApiInterface
     */
    requestLLMBusiness(requestsRequestLLMBusinessPost?: RequestsRequestLLMBusinessPost, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Store a LLM personal request
     * @summary LLM personal request
     * @param {RequestsRequestLLMPersonalPost} [requestsRequestLLMPersonalPost] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApiInterface
     */
    requestLLMPersonal(requestsRequestLLMPersonalPost?: RequestsRequestLLMPersonalPost, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for requestAgentPlacement operation in RequestsApi.
 * @export
 * @interface RequestsApiRequestAgentPlacementRequest
 */
export interface RequestsApiRequestAgentPlacementRequest {
    /**
     * 
     * @type {RequestsRequestAgentPlacementPost}
     * @memberof RequestsApiRequestAgentPlacement
     */
    readonly requestsRequestAgentPlacementPost?: RequestsRequestAgentPlacementPost
}

/**
 * Request parameters for requestHardwareRent operation in RequestsApi.
 * @export
 * @interface RequestsApiRequestHardwareRentRequest
 */
export interface RequestsApiRequestHardwareRentRequest {
    /**
     * 
     * @type {RequestsRequestHardwareRentPost}
     * @memberof RequestsApiRequestHardwareRent
     */
    readonly requestsRequestHardwareRentPost?: RequestsRequestHardwareRentPost
}

/**
 * Request parameters for requestHardwareRentOut operation in RequestsApi.
 * @export
 * @interface RequestsApiRequestHardwareRentOutRequest
 */
export interface RequestsApiRequestHardwareRentOutRequest {
    /**
     * 
     * @type {RequestsRequestHardwareRentOutPost}
     * @memberof RequestsApiRequestHardwareRentOut
     */
    readonly requestsRequestHardwareRentOutPost?: RequestsRequestHardwareRentOutPost
}

/**
 * Request parameters for requestLLMBusiness operation in RequestsApi.
 * @export
 * @interface RequestsApiRequestLLMBusinessRequest
 */
export interface RequestsApiRequestLLMBusinessRequest {
    /**
     * 
     * @type {RequestsRequestLLMBusinessPost}
     * @memberof RequestsApiRequestLLMBusiness
     */
    readonly requestsRequestLLMBusinessPost?: RequestsRequestLLMBusinessPost
}

/**
 * Request parameters for requestLLMPersonal operation in RequestsApi.
 * @export
 * @interface RequestsApiRequestLLMPersonalRequest
 */
export interface RequestsApiRequestLLMPersonalRequest {
    /**
     * 
     * @type {RequestsRequestLLMPersonalPost}
     * @memberof RequestsApiRequestLLMPersonal
     */
    readonly requestsRequestLLMPersonalPost?: RequestsRequestLLMPersonalPost
}

/**
 * RequestsApi - object-oriented interface
 * @export
 * @class RequestsApi
 * @extends {BaseAPI}
 */
export class RequestsApi extends BaseAPI implements RequestsApiInterface {
    /**
     * Store an agent placement request
     * @summary Agent placement request
     * @param {RequestsApiRequestAgentPlacementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApi
     */
    public requestAgentPlacement(requestParameters: RequestsApiRequestAgentPlacementRequest = {}, options?: RawAxiosRequestConfig) {
        return RequestsApiFp(this.configuration).requestAgentPlacement(requestParameters.requestsRequestAgentPlacementPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a hardware rent request
     * @summary Hardware rent request
     * @param {RequestsApiRequestHardwareRentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApi
     */
    public requestHardwareRent(requestParameters: RequestsApiRequestHardwareRentRequest = {}, options?: RawAxiosRequestConfig) {
        return RequestsApiFp(this.configuration).requestHardwareRent(requestParameters.requestsRequestHardwareRentPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a hardware rent out request
     * @summary Hardware rent out request
     * @param {RequestsApiRequestHardwareRentOutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApi
     */
    public requestHardwareRentOut(requestParameters: RequestsApiRequestHardwareRentOutRequest = {}, options?: RawAxiosRequestConfig) {
        return RequestsApiFp(this.configuration).requestHardwareRentOut(requestParameters.requestsRequestHardwareRentOutPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a LLM business request
     * @summary LLM business request
     * @param {RequestsApiRequestLLMBusinessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApi
     */
    public requestLLMBusiness(requestParameters: RequestsApiRequestLLMBusinessRequest = {}, options?: RawAxiosRequestConfig) {
        return RequestsApiFp(this.configuration).requestLLMBusiness(requestParameters.requestsRequestLLMBusinessPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a LLM personal request
     * @summary LLM personal request
     * @param {RequestsApiRequestLLMPersonalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequestsApi
     */
    public requestLLMPersonal(requestParameters: RequestsApiRequestLLMPersonalRequest = {}, options?: RawAxiosRequestConfig) {
        return RequestsApiFp(this.configuration).requestLLMPersonal(requestParameters.requestsRequestLLMPersonalPost, options).then((request) => request(this.axios, this.basePath));
    }
}

